import React, { useEffect, useState } from "react";
import BottomActionBar from "./BottomActionBar";
import { albums } from "../Accests/images"; // album data import

const Gallery = () => {
    const [showActionBar, setShowActionBar] = useState(true);
    const [selectedAlbum, setSelectedAlbum] = useState(null);
    const [selectedMedia, setSelectedMedia] = useState(null);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const isVideo = (src) => {
        return typeof src === "string" && src.toLowerCase().endsWith(".mp4");
    };

    return (
        <>
            <BottomActionBar visible={showActionBar} />

            <div id="gallery" className="p-4 bg-gray-50 dark:bg-gray-900 mt-12">
                <h1 className="text-white font-bold text-4xl text-center mt-24 sm:mt-28 md:mt-10 lg:mt-4">
                    Gallery
                </h1>

                {selectedAlbum === null ? (
                    // Album thumbnails
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 mt-8">
                        {albums.map((album) => (
                            <div
                                key={album.id}
                                onClick={() => setSelectedAlbum(album)}
                                className="cursor-pointer"
                            >
                                <img
                                    src={album.cover}
                                    alt={album.name}
                                    className="w-full aspect-square object-cover rounded-lg shadow-lg hover:scale-105 transition-transform"
                                />
                                <h2 className="text-center mt-2 text-white font-semibold">
                                    {album.name}
                                </h2>
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        <button
                            onClick={() => setSelectedAlbum(null)}
                            className="mt-6 mb-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
                        >
                            ← Back to Albums
                        </button>

                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-4">
                            {/* Photos */}
                            {selectedAlbum.photos?.map((src, index) => (
                                <div
                                    key={`photo-${index}`}
                                    onClick={() => setSelectedMedia(src)}
                                    className="cursor-pointer"
                                >
                                    <img
                                        src={src}
                                        alt={`Photo ${index + 1}`}
                                        className="w-full aspect-square object-cover rounded-lg shadow-lg hover:scale-105 transition-transform"
                                    />
                                </div>
                            ))}

                            {/* Videos with play icon */}
                            {selectedAlbum.videos?.map((src, index) => (
                                <div
                                    key={`video-${index}`}
                                    onClick={() => setSelectedMedia(src)}
                                    className="relative cursor-pointer"
                                >
                                    <video
                                        src={src}
                                        className="w-full aspect-square object-cover rounded-lg shadow-lg"
                                        muted
                                        playsInline
                                        preload="metadata"
                                    />
                                    {/* Play button overlay */}
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="bg-black bg-opacity-50 rounded-full p-3">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-8 w-8 text-white"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M14.752 11.168l-5.197-3.03A1 1 0 008 9.03v5.94a1 1 0 001.555.832l5.197-3.03a1 1 0 000-1.664z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {/* Fullscreen modal for photo or video */}
                {selectedMedia && (
                    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
                        <div className="relative max-w-3xl w-full px-4">
                            {isVideo(selectedMedia) ? (
                                <video
                                    src={selectedMedia}
                                    controls
                                    autoPlay
                                    className="w-full h-auto rounded-lg shadow-lg"
                                />
                            ) : (
                                <img
                                    src={selectedMedia}
                                    alt="Selected"
                                    className="w-full h-auto rounded-lg shadow-lg"
                                />
                            )}
                            <button
                                onClick={() => setSelectedMedia(null)}
                                className="absolute top-2 right-2 text-white text-xl bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-75 transition"
                            >
                                &times;
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Gallery;
